import { createFileRoute, useRouter } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/atoms/button';
import { Skeleton } from '@/components/atoms/skeleton';
import { DepositDetailPanel } from '@/components/organisms/deposits/DepositDetailPanel';
import { useDeposit } from '@/hooks/deposits';

export const Route = createFileRoute('/_dashboard/dashboard/deposits/$id')({
  component: DepositDetailRoute,
});

function DepositDetailRoute() {
  const { id } = Route.useParams();
  const router = useRouter();
  const { data: deposit, isLoading, isError } = useDeposit(id);

  if (isLoading) {
    return (
      <div className="h-full min-h-0 p-5">
        <Skeleton className="h-7 w-52" />
        <Skeleton className="mt-2 h-4 w-36" />
        <Skeleton className="mt-8 h-64 w-full" />
      </div>
    );
  }

  if (isError || !deposit) {
    return (
      <div className="page-enter mx-auto max-w-3xl space-y-4 p-4 sm:p-6">
        <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-4 text-sm text-destructive">
          Deposit not found.
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() =>
            void router.navigate({ to: '/dashboard/deposits', search: (prev) => prev as never })
          }
        >
          <ArrowLeft className="mr-1 size-4" />
          Back to Deposits
        </Button>
      </div>
    );
  }

  return <DepositDetailPanel deposit={deposit} />;
}
